export enum WizbiiCarouselActions {
  MOUNTED = 'mounted',
  UPDATED = 'updated',
  MOVE = 'move',
  MOVED = 'moved',
  DRAG = 'drag',
  DRAGGED = 'dragged',
  VISIBLE = 'visible',
  HIDDEN = 'hidden',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  CLICK = 'click',
  ARROWS_MOUNTED = 'arrows:mounted',
  ARROWS_UPDATED = 'arrows:updated',
  PAGINATION_MOUNTED = 'pagination:mounted',
  PAGINATION_UPDATED = 'pagination:updated',
  NAVIGATION_MOUNTED = 'navigation:mounted',
  AUTOPLAY_PLAY = 'autoplay:play',
  AUTOPLAY_PLAYING = 'autoplay:playing',
  AUTOPLAY_PAUSE = 'autoplay:pause',
  LAZYLOADING_LOADED = 'lazyload:loaded',
}
